export default "__VITE_ASSET__CADXW2lG__"